module.exports = __webpack_public_path__ + "static/media/main-banner1.689fc5a8.png";